import React, {useCallback} from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {useSelector} from 'react-redux';
import { formatShortDateEnUs } from '../../utils/formatDatetime';
import TimeCountdown from '../common/countdown';
import { formatData } from '../../utils/StringHelper';
import { formatNumberCurrency } from '../../utils/formatNumberCurrency';
import { CHAINID_FULLNAME } from '../../constants';
import { getNetworkObject } from '../../utils/campaignUltils';
// import { useNavigate } from "react-router-dom";

const ItemIDO = ({item, campaignPrices}) => {
    let location = useLocation();

    const { 
        title,
        status,
        network,
        totalRaise,
        acceptCurrency,
        idoRate,
        bannerURL,
        logoUrl,
        tokenInform,
        startIDO,
        rounds
    } = item; 
    let handleStatus = status.toLowerCase();
    if (handleStatus === 'tba')
        handleStatus = 'upcoming';
    const { symbol, tokenId } = tokenInform;
    const startIDODate = new Date(startIDO);

    
    const priceTokenArray = campaignPrices && campaignPrices.filter(function (itemPrice) {
        return itemPrice.id === tokenId;
    });

    let currentPrice = priceTokenArray && priceTokenArray[0] && priceTokenArray[0].current_price && Number(priceTokenArray[0].current_price.toFixed(5));
    
    const conversionRateNumber = Number(idoRate);
    let roiToken = (conversionRateNumber !== 0 && currentPrice > conversionRateNumber) ? (+currentPrice / conversionRateNumber)*100 : (currentPrice ? (-conversionRateNumber / currentPrice*100) : 0);
    roiToken = roiToken ? roiToken.toFixed(0) : '';

    rounds && rounds.sort(function(a,b){
        return a.id - b.id;
    });

    const roundRaiseRenderer = rounds && rounds.map((item,key) => {
        return (
            <p className="c-list__row" key={key}>
                <span>{item.round}:</span>
                <span>{formatData(item.totalRaise , acceptCurrency)}</span>
            </p>
        );
    });

    const networkChain = getNetworkObject(network);

    if(location.pathname==='/launchpad/completed') {
        return(
            <Link to={item.handle}>
                <div className="c-list__item">
                    <div className="c-list__logo">
                        <div className="c-list__img">
                            <img src={bannerURL} alt={title} />
                            {item?.modelType === 1
                                ? <div className={`c-list__status protected`} style={{textTransform: 'capitalize'}}>
                                   {/* <img src='../images/protected.svg'></img> */}
                                    Protected
                                  </div>
                                : <div className={`c-list__status`} style={{textTransform: 'capitalize'}}>Self-determined</div>
                            }
                           
                        </div>
                        <div className="c-list__title">
                            <span><img src={logoUrl} alt={title} /></span>
                            {title}
                        </div>
                    </div>
                    <div className="c-list__content">
                        <p className="c-list__row">
                            <span>IDO Date</span>
                            <span>{startIDO && formatShortDateEnUs(startIDODate)}</span>
                        </p>
                        <p className="c-list__row">
                            <span>Token</span>
                            <span>{symbol}</span>
                        </p>
                        <p className="c-list__row">
                            <span>IDO Rate</span>
                            <span>{formatData(idoRate, acceptCurrency)}</span>
                        </p>
                        <p className="c-list__row">
                            <span>Current Price</span>
                            <span>{formatData(currentPrice, acceptCurrency)}</span>
                        </p>
                        <p className="c-list__row">
                            <span>ROI</span>
                            {roiToken && currentPrice !== 0 ? <span className={`${roiToken >= 0 ? 'up' : 'down'}`}>{formatNumberCurrency(Math.abs(roiToken))}%</span> : <span className="">--</span>}
                        </p>
                        <p className="c-list__row">
                            <span>Network</span>
                            <span>
                                <img src={networkChain.logo} alt={networkChain.name} />
                                {networkChain.name}
                            </span>
                        </p>
                    </div>
                </div>
            </Link>
        );
    }
    return(
        <div className="c-list__item">
            <div className="c-list__img">
                <Link to={`/launchpad/${handleStatus.toLowerCase(0)}/${item.handle}`}>
                    <img src={bannerURL} alt={title} />
                    {item?.modelType === 1
                        ? <div className={`c-list__status protected`} style={{textTransform: 'capitalize'}}>
                            {/* <img src='../images/protected.svg'></img> */}
                            Protected
                        </div>
                        : <div className={`c-list__status`} style={{textTransform: 'capitalize'}}>Self-determined</div>
                    }
                </Link>
            </div>
            <div className="c-list__body">
                <h2 className="c-list__head">
                    {title}
                    <span><img src={logoUrl} alt={title} /></span>
                </h2>
                <p className="c-list__row">
                    <span>Network:</span>
                    <span>
                        <img src={networkChain.logo} alt={networkChain.name} />
                        {networkChain.name}
                    </span>
                </p>
                <p className="c-list__row">
                    <span>Total Raise:</span>
                    <span>{formatData(totalRaise, acceptCurrency)}</span>
                </p>
                <p className="c-list__row">
                    <span>IDO Rate:</span>
                    <span>{formatData(idoRate, acceptCurrency)}</span>
                </p>
                <span className="c-list__line"></span>  
                {rounds.length >0 ? roundRaiseRenderer :
                    <>
                    <p className="c-list__row">
                        <span>Guaranteed:</span>
                        <span>--</span>
                    </p>
                    <p className="c-list__row">
                        <span>Private:</span>
                        <span>--</span>
                    </p>
                    <p className="c-list__row">
                        <span>Community:</span>
                        <span>--</span>
                    </p></>
                }
                
            </div>
            <div className="c-list__footer">
                <span className="c-list__line"></span>
                <p>
                    <TimeCountdown item={item} />
                </p>
                <Link to={`/launchpad/${handleStatus.toLowerCase(0)}/${item.handle}`}>Detail</Link>
            </div>
        </div>
    );
}

export default ItemIDO;